import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { CheckinLogsTable } from '@/components/tables/CheckinLogsTable'
import { Layout, PageHeader } from 'antd'

const pageTitle = '来館履歴'

export default () => (
  <Root title={pageTitle}>
    <Layout>
      <StyledPageHeader title={pageTitle} />
      <CheckinLogsTable />
    </Layout>
  </Root>
)

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`
